module.exports = __webpack_public_path__ + "af80ea98d0f482d89bcbc73de9a57691.png";